import React, { useState, useEffect } from 'react';
import '../styles/Contact.css';

const Contact = () => {
  const [titleText, setTitleText] = useState('');
  const [showTitleCursor, setShowTitleCursor] = useState(true);
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    const title = "Get in Touch";
    let currentIndex = 0;

    const typeTitle = () => {
      if (currentIndex < title.length) {
        setTitleText(title.substring(0, currentIndex + 1));
        currentIndex++;
        setTimeout(typeTitle, 150);
      } else {
        setTimeout(() => {
          setShowTitleCursor(false);
          setShowContent(true);
        }, 1000);
      }
    };

    typeTitle();
  }, []);

  return (
    <section className="contact-section">
      <div className="terminal-window">
        <div className="terminal-header">
          <div className="terminal-controls">
            <span className="control close"></span>
            <span className="control minimize"></span>
            <span className="control maximize"></span>
          </div>
          <div className="terminal-title">contact.exe</div>
        </div>
        <div className="terminal-body">
          <h1 className="contact-title">
            {titleText}
            {showTitleCursor && <span className="title-cursor">_</span>}
          </h1>
          {showContent && (
            <>
              <div className="contact-info">
                <div className="contact-item">
                  <span className="prompt">$</span>
                  <span className="command">email</span>
                  <a href="mailto:michael_sh@live.com" className="contact-link">
                    michael_sh@live.com
                  </a>
                </div>
                <div className="contact-item">
                  <span className="prompt">$</span>
                  <span className="command">linkedin</span>
                  <a href="https://linkedin.com/in/msham98" target="_blank" rel="noopener noreferrer" className="contact-link">
                    linkedin.com/in/msham98
                  </a>
                </div>
                {/* <div className="contact-item">
                  <span className="prompt">$</span>
                  <span className="command">github</span>
                  <a href="https://github.com/your-username" target="_blank" rel="noopener noreferrer" className="contact-link">
                    github.com/your-username
                  </a>
                </div> */}
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default Contact; 